export default "__VITE_ASSET__Dn7CDS3I__"